// extracted by mini-css-extract-plugin
module.exports = {"page":"__12v-lithium-battery_page__vLLLc"};